import React, { Component } from 'react';
import i18n from 'i18n-react';

import { baseAppId } from 'settings';
import { BackVideo, APIHandler } from 'C4';

const { userAgent } = window.navigator;

const getBrowser = () => {
  if (userAgent.includes('Chrome') && !userAgent.includes('OPR')) return 'chrome';
  if (userAgent.includes('OPR') && userAgent.includes('Chrome')) return 'opera';
  if (userAgent.includes('Firefox')) return 'firefox';
  if (userAgent.includes('Edge')) return 'edge';
  return '';
};

export default class CookieWarning extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appName: null,
      browser: null,
    };
  }

  componentDidMount() {
    APIHandler.getAppInfo(baseAppId)
      .then((res) => {
        const browser = getBrowser();
        this.setState({
          appName: res.app[0].appName,
          browser,
        });
      });
  }

  render() {
    const { appName, browser } = this.state;
    return (
      <div className="cookie__container">
        <div className="text__container">
          <h1>{i18n.translate('cookies.disabled')}</h1>
          {appName && <h2>{i18n.translate('cookies.use', { appName: `${appName}${appName.slice(-3) === 'app' ? '' : ' app'}` })}</h2>}
          {browser && (

          <h2>{i18n.translate('cookies.enable', {
            here: (
              <a target="_blank" rel="noopener noreferrer" href={`https://www.whatismybrowser.com/guides/how-to-enable-cookies/${browser}`}>
                {i18n.translate('cookies.here')}
              </a>
            ),
          })}
          </h2>
          )}
        </div>
      </div>
    );
  }
}
